import _extends from "@babel/runtime/helpers/extends";

/**
 * External dependencies
 */
import React, { forwardRef } from 'react';
import { useSubscription } from 'use-subscription';
import { createHigherOrderComponent } from '@wordpress/compose';
export default function rtlFactory(i18n) {
  // Subscription object (adapter) for the `useSubscription` hook
  var RtlSubscription = {
    getCurrentValue: function getCurrentValue() {
      return i18n.isRtl();
    },
    subscribe: function subscribe(callback) {
      i18n.on('change', callback);
      return function () {
        return i18n.off('change', callback);
      };
    }
  };

  function useRtl() {
    return useSubscription(RtlSubscription);
  }

  var withRtl = createHigherOrderComponent(function (WrappedComponent) {
    return forwardRef(function (props, ref) {
      var isRtl = useRtl();
      return React.createElement(WrappedComponent, _extends({}, props, {
        isRtl: isRtl,
        ref: ref
      }));
    });
  }, 'WithRTL');
  return {
    useRtl: useRtl,
    withRtl: withRtl
  };
}